import { render, staticRenderFns } from "./user-booking.vue?vue&type=template&id=5fa95637"
import script from "./user-booking.vue?vue&type=script&lang=js"
export * from "./user-booking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports